import React from 'react';

import { Cancel } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { MAXIMIZE_MAP } from 'appConstants';
import { useAppDispatch } from 'state/hooks';
import { setMaximize } from '../../state/workflowSlice';

export function ClosePanelButton() {
  const dispatch = useAppDispatch();
  const handleClick = () => {
    dispatch(setMaximize(MAXIMIZE_MAP));
  };

  return (
    <IconButton
      edge="end"
      aria-label="close"
      title="Close"
      color="primary"
      onClick={handleClick}
    >
      <Cancel />
    </IconButton>
  );
}
